import React from 'react';
import { Carousel } from 'react-bootstrap';
import './Slider.css';

function Slider() {
  // Define the total number of slides (images)
  const totalSlides = 8;

  return (
    <div className="slider-container">
      <Carousel>
        {Array.from({ length: totalSlides }).map((_, index) => (
          <Carousel.Item key={index} interval={3000}>
            <div className="carousel-image-container">
              <img
                className="carousel-image"
                src={`images/slider/slide${(index + 1).toString().padStart(2, '0')}.jpg`}
                alt={`Slide ${index + 1}`}
              />
            </div>
            <Carousel.Caption>
            </Carousel.Caption>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
}

export default Slider;
